import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-trip-type-tabs',
    imports: [NgClass],
    templateUrl: './trip-type-tabs.component.html',
    styleUrls: ['./trip-type-tabs.component.scss']
})
export class TripTypeTabs {
  @Input() value: 'outstation' | 'local' | 'airport' = 'local';
  @Output() valueChange = new EventEmitter<'outstation' | 'local' | 'airport'>();

  select(value: 'outstation' | 'local' | 'airport') {
    if (this.value !== value) {
      this.value = value;
      this.valueChange.emit(value);
    }
  }
}
